import React, { useEffect, useState } from 'react';
import { Modal, BREAKPOINTS } from '@manulife/mux';
import { Cross } from '@manulife/mux-cds-icons';
import { Grid } from '@mui/material';
import { videoGuidStyle as styles } from '../../styles/videoGuide.styles';

import OrangeVideoIc from 'images/orange_cicle_video_ic.png';

const VITALITY_VIDEO_URL =
  'https://players.brightcove.net/72312192001/sqTCIY0Mf_default/index.html?videoId=6319659549112';

const VideoGuide = (props) => {
  let { isVideoModalVisible, setVideoModalVisible } = props;

  let [hovered, setHover] = useState(false);

  useEffect(() => {
    // Added this dynamic CSS to handle Video Modal alignments
    if (isVideoModalVisible) {
      let videoModalEle = document.getElementById('video-modal');
      videoModalEle.style.overflow = 'hidden';
      videoModalEle.style.border = 'none';
      videoModalEle.style.boxSizing = 'none';
      videoModalEle.style.background = 'none';
    }
  }, [isVideoModalVisible, hovered]);

  return (
    <Grid>
      <Grid item xs={12}>
        <div style={styles.watchVideoContainer}>
          <span
            id="video-guide-button"
            onMouseOver={() => setHover(true)}
            onMouseOut={() => setHover(false)}
            onClick={() => setVideoModalVisible(true)}
            style={styles.videoIconTextContainer}
          >
            <img
              src={OrangeVideoIc}
              style={styles.videoIcon}
              alt="watch video"
            />
            <span style={styles.videoWatchText2}>
              Watch the video to learn more about Vitality
            </span>
          </span>
        </div>
      </Grid>
      <Modal
        id="video-modal"
        isOpen={isVideoModalVisible}
        onClose={() => setVideoModalVisible(false)}
        showCloseButton={false}
        ariaLabel="Timeout Modal"
        customStyle={{
          modalStyle: {
            height: '50vh',
            width: '65%',
            padding: '0px',
            margin: '0px',
            border: '0px solid !important',
            background: 'none !important',
            lineHeight: '0px',
            overflow: 'hiddden !important',
            media: [
              {
                maximum: BREAKPOINTS.PHONE_PORTRAIT_MED,
                width: '100%',
                height: '100%',
              },
            ],
          },
        }}
        ariaLabelledBy="Registration-Guide-Video"
        ariaDescribedBy="content"
      >
        <Cross
          onClick={() => setVideoModalVisible(false)}
          style={styles.cross}
        />
        <iframe
          title="registration-guid-video"
          id="registration-guid-video"
          aria-label="Registration Guide Video"
          height="100%"
          width="100%"
          src={VITALITY_VIDEO_URL}
          referrerPolicy="no-referrer"
          allowfullscreen=""
          allow="fullscreen"
        />
      </Modal>
    </Grid>
  );
};

export default VideoGuide;
